import { useEffect } from 'react'

export default function useMemoLinkHandler() {
  useEffect(() => {
    const getAnchor = (e: Event): HTMLAnchorElement | null => {
      const target = e.target as HTMLElement | null
      if (!target) return null
      return target.closest(
        '.ql-editor a, .tour-memo a'
      ) as HTMLAnchorElement | null
    }

    const handleTouchStart = (e: TouchEvent) => {
      const anchor = getAnchor(e)
      if (
        anchor &&
        !anchor.isContentEditable &&
        !anchor.closest('[contenteditable="true"]')
      ) {
        e.stopPropagation()
      }
    }

    const handleTouchEnd = (e: TouchEvent) => {
      const anchor = getAnchor(e)
      if (
        anchor &&
        !anchor.isContentEditable &&
        !anchor.closest('[contenteditable="true"]')
      ) {
        e.stopPropagation()
      }
    }

    const handleClick = (e: MouseEvent) => {
      const anchor = getAnchor(e)
      if (
        anchor &&
        !anchor.isContentEditable &&
        !anchor.closest('[contenteditable="true"]')
      ) {
        const rawHref = anchor.getAttribute('href')
        if (rawHref && rawHref !== '#') {
          const isJavaScriptUrl = /^javascript:/i.test(rawHref.trim())
          if (isJavaScriptUrl) return

          e.preventDefault()
          e.stopPropagation()
          const href = /^(https?:\/\/|mailto:|tel:|\/)/i.test(rawHref)
            ? rawHref
            : `https://${rawHref}`
          window.open(href, '_blank', 'noopener,noreferrer')
        }
      }
    }

    window.addEventListener('touchstart', handleTouchStart, { capture: true })
    window.addEventListener('touchend', handleTouchEnd, { capture: true })
    window.addEventListener('click', handleClick, { capture: true })

    return () => {
      window.removeEventListener('touchstart', handleTouchStart, {
        capture: true
      })
      window.removeEventListener('touchend', handleTouchEnd, {
        capture: true
      })
      window.removeEventListener('click', handleClick, { capture: true })
    }
  }, [])
}
